import userService from "@/endpoints/userService";
import ShowToaster from "@/toaster";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const updateBrandColor = createAsyncThunk<
  { brandId: number | string; color: string; type: string } | null,
  { brandId: number | string; marketId: number; userId: number; color: string; type: string },
  { rejectValue: string }
>(
  "brands/updateColor",
  async ({ brandId, color, marketId, userId, type }, thunkAPI) => {
    try {
      const response: string = (await userService.brands.updateBrandColor({
        brandId,
        userId,
        marketId,
        color,
        type
      })) as any;
      return response ? { brandId, color, type } : null;
    } catch (err: any) {
      ShowToaster.error("Failed to update brand color.");
      return thunkAPI.rejectWithValue(
        "Failed to update brand color. " + err.message
      );
    }
  }
);
